module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_L2-4e72a3cdb784cf9423a95225c8f81057.png";